<template>
    <v-stepper v-model="currentStep" v-bind="$props">
        <v-stepper-header>
            <v-stepper-step :complete="currentStep > 1" :step="1" :editable="currentStep > 1 && !submitting" :edit-icon="$vuetify.icons.complete">
                Ticketauswahl
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 2" :step="2" :editable="currentStep > 2 && !submitting" :edit-icon="$vuetify.icons.complete">
                Teilnehmerdaten
            </v-stepper-step>
            <v-divider v-if="this.organizer.slug!=='mbb'"></v-divider>
            <v-stepper-step v-if="this.organizer.slug!=='mbb'" :complete="currentStep > 3" :step="3" :editable="currentStep > 3 && !submitting" :edit-icon="$vuetify.icons.complete">
                Rechnungdaten
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > (this.organizer.slug==='mbb' ? 3 : 4)" :step="this.organizer.slug==='mbb' ? 3 : 4" :edit-icon="$vuetify.icons.complete">
                Bezahlung
            </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
            <v-stepper-content :step="1">
                <ticket-selection-step v-if="event.group_sale"></ticket-selection-step>
                <single-ticket-selection-step v-else></single-ticket-selection-step>
            </v-stepper-content>
            <v-stepper-content :step="2">
                <attendees-step></attendees-step>
            </v-stepper-content>
            <v-stepper-content :step="3" v-if="this.organizer.slug!=='mbb'">
                <invoice-step></invoice-step>
            </v-stepper-content>
            <v-stepper-content :step="this.organizer.slug==='mbb' ? 3 : 4">
                <payment-step></payment-step>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
</template>
<script>
    import {mapState} from 'vuex'

    export default {
        props: {
            'alt-labels': Boolean,
            'dark': Boolean,
            'non-linear': Boolean,
        },
        computed: {
            ...mapState('form', [
                'event',
                'submitting',
                "organizer"
            ]),
            currentStep: {
                get: function () {
                    return this.$store.state.stepper.step;
                },
                set: function (newValue) {
                    this.$store.commit('stepper/setStep', newValue)
                }
            },
        }
    }
</script>

<style scoped>
    >>> .v-stepper__wrapper {
        overflow: visible;
    }
</style>
